<template>
    <div
        class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-cursor-wait tw-bg-[rgba(255,255,255,.66)]"
    >
        <slot><i class="mdi mdi-loading mdi-spin tw-text-black"></i></slot>
    </div>
</template>
